import { render, staticRenderFns } from "./NewCrossPropertyEditor.vue?vue&type=template&id=cf8dbd5e&scoped=true&"
import script from "./NewCrossPropertyEditor.vue?vue&type=script&lang=ts&"
export * from "./NewCrossPropertyEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf8dbd5e",
  null
  
)

export default component.exports